// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file graph-sync.proto (package GraphSync, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file graph-sync.proto.
 */
export const file_graph_sync: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
  );

/**
 * @generated from message GraphSync.GraphSyncRef
 */
export type GraphSyncRef = Message<"GraphSync.GraphSyncRef"> & {
  /**
   * @generated from field: GraphSync.RefType type = 1;
   */
  type: RefType;

  /**
   * @generated from field: bytes value = 2;
   */
  value: Uint8Array;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message GraphSync.GraphSyncRef.
 * Use `create(GraphSyncRefSchema)` to create a new message.
 */
export const GraphSyncRefSchema: GenMessage<GraphSyncRef> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 0);

/**
 * @generated from message GraphSync.GraphSyncActor
 */
export type GraphSyncActor = Message<"GraphSync.GraphSyncActor"> & {
  /**
   * @generated from field: GraphSync.GraphSyncActorType type = 1;
   */
  type: GraphSyncActorType;

  /**
   * @generated from field: bytes id = 2;
   */
  id: Uint8Array;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bytes effectiveUserId = 4;
   */
  effectiveUserId: Uint8Array;
};

/**
 * Describes the message GraphSync.GraphSyncActor.
 * Use `create(GraphSyncActorSchema)` to create a new message.
 */
export const GraphSyncActorSchema: GenMessage<GraphSyncActor> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 1);

/**
 * @generated from message GraphSync.GraphSyncData
 */
export type GraphSyncData = Message<"GraphSync.GraphSyncData"> & {
  /**
   * @generated from field: GraphSync.GraphSyncDataType type = 1;
   */
  type: GraphSyncDataType;

  /**
   * @generated from field: GraphSync.GraphSyncRef ref = 2;
   */
  ref?: GraphSyncRef;

  /**
   * @generated from field: GraphSync.GraphSyncRef parentRef = 3;
   */
  parentRef?: GraphSyncRef;

  /**
   * @generated from field: bytes content = 4;
   */
  content: Uint8Array;

  /**
   * @generated from field: string path = 5;
   */
  path: string;
};

/**
 * Describes the message GraphSync.GraphSyncData.
 * Use `create(GraphSyncDataSchema)` to create a new message.
 */
export const GraphSyncDataSchema: GenMessage<GraphSyncData> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 2);

/**
 * @generated from message GraphSync.GraphSyncDataPlus
 */
export type GraphSyncDataPlus = Message<"GraphSync.GraphSyncDataPlus"> & {
  /**
   * @generated from field: GraphSync.GraphSyncData data = 1;
   */
  data?: GraphSyncData;

  /**
   * @generated from field: int64 timestamp = 2;
   */
  timestamp: bigint;

  /**
   * @generated from field: GraphSync.GraphSyncActor actor = 3;
   */
  actor?: GraphSyncActor;
};

/**
 * Describes the message GraphSync.GraphSyncDataPlus.
 * Use `create(GraphSyncDataPlusSchema)` to create a new message.
 */
export const GraphSyncDataPlusSchema: GenMessage<GraphSyncDataPlus> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 3);

/**
 * @generated from message GraphSync.GraphSyncQuery
 */
export type GraphSyncQuery = Message<"GraphSync.GraphSyncQuery"> & {
  /**
   * @generated from field: bytes streamId = 1;
   */
  streamId: Uint8Array;

  /**
   * @generated from field: bytes origin = 2;
   */
  origin: Uint8Array;

  /**
   * @generated from field: int64 syncPoint = 3;
   */
  syncPoint: bigint;

  /**
   * @generated from field: int32 maxCount = 4;
   */
  maxCount: number;
};

/**
 * Describes the message GraphSync.GraphSyncQuery.
 * Use `create(GraphSyncQuerySchema)` to create a new message.
 */
export const GraphSyncQuerySchema: GenMessage<GraphSyncQuery> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 4);

/**
 * @generated from message GraphSync.GraphSyncResult
 */
export type GraphSyncResult = Message<"GraphSync.GraphSyncResult"> & {
  /**
   * @generated from field: bytes streamId = 2;
   */
  streamId: Uint8Array;

  /**
   * @generated from field: int64 syncPoint = 3;
   */
  syncPoint: bigint;

  /**
   * @generated from field: repeated GraphSync.GraphSyncDataPlus data = 4;
   */
  data: GraphSyncDataPlus[];

  /**
   * @generated from field: bool hasMore = 5;
   */
  hasMore: boolean;
};

/**
 * Describes the message GraphSync.GraphSyncResult.
 * Use `create(GraphSyncResultSchema)` to create a new message.
 */
export const GraphSyncResultSchema: GenMessage<GraphSyncResult> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 5);

/**
 * @generated from message GraphSync.GraphSyncMultiQuery
 */
export type GraphSyncMultiQuery = Message<"GraphSync.GraphSyncMultiQuery"> & {
  /**
   * @generated from field: repeated GraphSync.GraphSyncQuery queries = 1;
   */
  queries: GraphSyncQuery[];
};

/**
 * Describes the message GraphSync.GraphSyncMultiQuery.
 * Use `create(GraphSyncMultiQuerySchema)` to create a new message.
 */
export const GraphSyncMultiQuerySchema: GenMessage<GraphSyncMultiQuery> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 6);

/**
 * @generated from message GraphSync.GraphSyncMultiResult
 */
export type GraphSyncMultiResult = Message<"GraphSync.GraphSyncMultiResult"> & {
  /**
   * @generated from field: repeated GraphSync.GraphSyncResult results = 1;
   */
  results: GraphSyncResult[];
};

/**
 * Describes the message GraphSync.GraphSyncMultiResult.
 * Use `create(GraphSyncMultiResultSchema)` to create a new message.
 */
export const GraphSyncMultiResultSchema: GenMessage<GraphSyncMultiResult> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 7);

/**
 * @generated from message GraphSync.GraphSyncAddDataRequest
 */
export type GraphSyncAddDataRequest = Message<"GraphSync.GraphSyncAddDataRequest"> & {
  /**
   * @generated from field: GraphSync.GraphSyncRef origin = 1;
   */
  origin?: GraphSyncRef;

  /**
   * @generated from field: repeated GraphSync.GraphSyncData data = 2;
   */
  data: GraphSyncData[];
};

/**
 * Describes the message GraphSync.GraphSyncAddDataRequest.
 * Use `create(GraphSyncAddDataRequestSchema)` to create a new message.
 */
export const GraphSyncAddDataRequestSchema: GenMessage<GraphSyncAddDataRequest> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 8);

/**
 * @generated from message GraphSync.GraphSyncLeafsQuery
 */
export type GraphSyncLeafsQuery = Message<"GraphSync.GraphSyncLeafsQuery"> & {
  /**
   * @generated from field: repeated bytes vertices = 2;
   */
  vertices: Uint8Array[];
};

/**
 * Describes the message GraphSync.GraphSyncLeafsQuery.
 * Use `create(GraphSyncLeafsQuerySchema)` to create a new message.
 */
export const GraphSyncLeafsQuerySchema: GenMessage<GraphSyncLeafsQuery> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 9);

/**
 * @generated from message GraphSync.GraphSyncRefsResult
 */
export type GraphSyncRefsResult = Message<"GraphSync.GraphSyncRefsResult"> & {
  /**
   * @generated from field: repeated GraphSync.GraphSyncRef refs = 1;
   */
  refs: GraphSyncRef[];
};

/**
 * Describes the message GraphSync.GraphSyncRefsResult.
 * Use `create(GraphSyncRefsResultSchema)` to create a new message.
 */
export const GraphSyncRefsResultSchema: GenMessage<GraphSyncRefsResult> =
  /*@__PURE__*/
  messageDesc(file_graph_sync, 10);

/**
 * @generated from enum GraphSync.RefType
 */
export enum RefType {
  /**
   * @generated from enum value: RFT_GENERAL = 0;
   */
  RFT_GENERAL = 0,

  /**
   * @generated from enum value: RFT_USER = 1;
   */
  RFT_USER = 1,

  /**
   * @generated from enum value: RFT_DEVICE = 2;
   */
  RFT_DEVICE = 2,

  /**
   * @generated from enum value: RFT_REC = 3;
   */
  RFT_REC = 3,

  /**
   * @generated from enum value: RFT_FOLDER = 4;
   */
  RFT_FOLDER = 4,

  /**
   * @generated from enum value: RFT_TEAM = 5;
   */
  RFT_TEAM = 5,

  /**
   * @generated from enum value: RFT_ENTERPRISE = 6;
   */
  RFT_ENTERPRISE = 6,

  /**
   * @generated from enum value: RFT_PAM_DIRECTORY = 7;
   */
  RFT_PAM_DIRECTORY = 7,

  /**
   * @generated from enum value: RFT_PAM_MACHINE = 8;
   */
  RFT_PAM_MACHINE = 8,

  /**
   * @generated from enum value: RFT_PAM_DATABASE = 9;
   */
  RFT_PAM_DATABASE = 9,

  /**
   * @generated from enum value: RFT_PAM_USER = 10;
   */
  RFT_PAM_USER = 10,

  /**
   * @generated from enum value: RFT_PAM_NETWORK = 11;
   */
  RFT_PAM_NETWORK = 11,

  /**
   * @generated from enum value: RFT_PAM_BROWSER = 12;
   */
  RFT_PAM_BROWSER = 12,

  /**
   * @generated from enum value: RFT_CONNECTION = 13;
   */
  RFT_CONNECTION = 13,

  /**
   * @generated from enum value: RFT_WORKFLOW = 14;
   */
  RFT_WORKFLOW = 14,

  /**
   * @generated from enum value: RFT_NOTIFICATION = 15;
   */
  RFT_NOTIFICATION = 15,

  /**
   * @generated from enum value: RFT_USER_INFO = 16;
   */
  RFT_USER_INFO = 16,

  /**
   * @generated from enum value: RFT_TEAM_INFO = 17;
   */
  RFT_TEAM_INFO = 17,

  /**
   * @generated from enum value: RFT_ROLE = 18;
   */
  RFT_ROLE = 18,
}

/**
 * Describes the enum GraphSync.RefType.
 */
export const RefTypeSchema: GenEnum<RefType> = /*@__PURE__*/ enumDesc(file_graph_sync, 0);

/**
 * @generated from enum GraphSync.GraphSyncDataType
 */
export enum GraphSyncDataType {
  /**
   * @generated from enum value: GSE_DATA = 0;
   */
  GSE_DATA = 0,

  /**
   * @generated from enum value: GSE_KEY = 1;
   */
  GSE_KEY = 1,

  /**
   * @generated from enum value: GSE_LINK = 2;
   */
  GSE_LINK = 2,

  /**
   * @generated from enum value: GSE_ACL = 3;
   */
  GSE_ACL = 3,

  /**
   * @generated from enum value: GSE_DELETION = 4;
   */
  GSE_DELETION = 4,
}

/**
 * Describes the enum GraphSync.GraphSyncDataType.
 */
export const GraphSyncDataTypeSchema: GenEnum<GraphSyncDataType> =
  /*@__PURE__*/
  enumDesc(file_graph_sync, 1);

/**
 * @generated from enum GraphSync.GraphSyncActorType
 */
export enum GraphSyncActorType {
  /**
   * @generated from enum value: GSA_USER = 0;
   */
  GSA_USER = 0,

  /**
   * @generated from enum value: GSA_SERVICE = 1;
   */
  GSA_SERVICE = 1,

  /**
   * @generated from enum value: GSA_PAM_GATEWAY = 2;
   */
  GSA_PAM_GATEWAY = 2,
}

/**
 * Describes the enum GraphSync.GraphSyncActorType.
 */
export const GraphSyncActorTypeSchema: GenEnum<GraphSyncActorType> =
  /*@__PURE__*/
  enumDesc(file_graph_sync, 2);
